import { render, staticRenderFns } from "./Especial.vue?vue&type=template&id=906cd8e2&scoped=true&"
import script from "./Especial.vue?vue&type=script&lang=js&"
export * from "./Especial.vue?vue&type=script&lang=js&"
import style0 from "./Especial.vue?vue&type=style&index=0&id=906cd8e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906cd8e2",
  null
  
)

export default component.exports